import { Check } from '@mui/icons-material';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import LoginWidget from './components/LoginWidget/LoginWidgetContainer';
import Layout from '../../../App/components/Layout/LayoutContainer';
import { loginError } from '../../AuthActions';
import {
  signupBulletIconSx,
  signupBulletsSx,
  signupBulletSx,
  signupBulletTextSx,
  signupLeftSx,
  signupMainSx,
  signupRightSx,
} from './signupSsrStyles';

const messages = defineMessages({
  title: {
    id: 'Signup.Title',
    defaultMessage: 'Sign up',
  },
  error404: {
    id: 'tokenNotFound',
    defaultMessage: 'Token not found, please sign up again.',
  },
  error400: {
    id: 'tokenExpired',
    defaultMessage: 'Token expired, please sign up again.',
  },
  error500: {
    id: 'unexpectedError',
    defaultMessage: 'Unexpected error, please sign up again.',
  },
});

const bullets = [
  {
    title: (
      <FormattedMessage
        id="Signup.Bullet1Title"
        defaultMessage="The first 500 surveys are on us"
      />
    ),
    desc: (
      <FormattedMessage
        id="Signup.Bullet1Desc"
        defaultMessage="No hidden costs. No credit card needed."
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id="Signup.Bullet2Title"
        defaultMessage="Start collecting feedback today"
      />
    ),
    desc: (
      <FormattedMessage
        id="Signup.Bullet2Desc"
        defaultMessage="With only a few clicks, no IT skills required."
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id="Signup.Bullet3Title"
        defaultMessage="Get the most for your money"
      />
    ),
    desc: (
      <FormattedMessage
        id="Signup.Bullet3Desc"
        defaultMessage="We cut our costs to the limit to provide the cheapest NPS tool."
      />
    ),
  },
];

function SignupPage(props) {
  const { formatMessage } = props.intl;
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const error = searchParams.get('confirmEmailError');
    if (['404', '400', '500'].includes(error)) {
      dispatch(loginError(formatMessage(messages[`error${error}`])));
    }
  }, [dispatch, formatMessage, searchParams]);

  return (
    <Layout title={formatMessage(messages.title)} disableGutters>
      <Grid container sx={signupMainSx}>
        <Grid xs={12} md={6} lg={5} sx={signupLeftSx}>
          <LoginWidget isSignup />
        </Grid>
        <Grid xs={12} md={6} lg={7} sx={signupRightSx}>
          <Box component="ol" sx={signupBulletsSx}>
            {bullets.map((bullet, index) => (
              <Box component="li" key={index} sx={signupBulletSx}>
                <Check sx={signupBulletIconSx} />
                <Box sx={signupBulletTextSx}>
                  <Box component="h2">{bullet.title}</Box>
                  <Box component="p">{bullet.desc}</Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}

SignupPage.propTypes = {
  intl: PropTypes.any.isRequired,
};

export default injectIntl(SignupPage);
